import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axiosInstance"; // Ensure this is the correct path for axios
import "./adLoginPage.css";

// Modal Component
const Modal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

const AdLoginPage = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobileNumber || !password) {
      setError("Please enter both mobile number and password.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post("/api/admin/login/verify", {
        mobileNumber,
        password,
      });

      if (response.data?.status === "success") {
        // ✅ Save login details
        localStorage.setItem("sessiontoken", response.data.sessionToken);
        localStorage.setItem("adminId", response.data.adminId);
        localStorage.setItem("userRole", "admin");

        setModalMessage("Login successful!");

        // ✅ Navigate to dashboard
        navigate("/admin/dashboard");
      } else {
        setError(response.data?.error || "Invalid mobile number or password.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError(
        error.response?.data?.error || "An unexpected error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reporterlogin">
      <Modal message={modalMessage} onClose={() => setModalMessage("")} />

      <div className="login-container">
        <h2>Today Local</h2>
        <h2>Admin Login</h2>

        {error && <p className="error-message">{error}</p>}

        <div className="input-group">
          <label>Mobile Number</label>
          <input
            type="text"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="Enter mobile number"
          />
        </div>

        <div className="input-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
          />
        </div>

        <button className="login-button" onClick={handleLogin} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </div>
    </div>
  );
};

export default AdLoginPage;
